 <template lang="pug">
include BaseMessage.pug
 </template>

<script>
import get from 'lodash/get';
// eslint-disable-next-line import/no-duplicates
import isEmpty from 'lodash/isEmpty';
// eslint-disable-next-line import/no-duplicates
import isUndefined from 'lodash/isEmpty';
import capitalize from 'lodash/capitalize';
import upperFirst from 'lodash/upperFirst';
import moment from 'moment';

import i18n from '../../../../mixins/i18n';
import { channelsInfo, getInitials } from '../../MessageUtils';
import { calculateSecondsInHours } from '../../../../helpers/durations';
import { LEAST_TIMEAGO_MAX_TIME } from '../../../../constants/durations';

import photo from '../../../../assets/messages/photo.jpg';

const CHANNELS = {
  WEBCHAT: 'webchat',
};

const BOT_EMAIL = 'bot@agentiq.com';

export default {
  name: 'baseMessage',
  mixins: [i18n],
  props: {
    message: {
      type: Object,
      default: () => ({}),
    },
    showIcons: Object,
    systemMessagesDisplay: {
      type: Boolean,
      default: true,
    },
    accountFieldsVisibility: {
      type: Array,
      default: () => [],
    },
    isTimestampAbsolute: Boolean,
  },
  data() {
    return {
      photo,
    };
  },
  methods: {
    format(time) {
      return moment().isSame(moment(time), 'day')
        ? moment(time).calendar()
        : moment(time).format('lll');
    },
    applyFilters(content) {
      const { sanitize, urlFilter, makePhoneNumbersDialable } = this.$filters;
      return makePhoneNumbersDialable(urlFilter(sanitize(content)));
    },
    handleVisibleChange(isVisible) {
      this.$emit('handleDropdownVisibleChange', isVisible);
    }
  },
  computed: {
    baseClass() {
      return {
        'message-customer': this.senderType === 'customers',
        'message-agent': this.senderType === 'agents',
      };
    },

    channel() {
      return CHANNELS.WEBCHAT;
    },

    messageDate() {
      if (isEmpty(this.message.created_at) || isUndefined(this.message.created_at)) {
        return '';
      }
      return this.message.created_at;
    },

    hasChannel() {
      return !!get(this.message, 'payload.channel', false);
    },

    channelInfo() {
      const channel = this.channel || get(this.message, 'payload.channel');
      return get(channelsInfo, channel, {
        icon: '',
        title: '',
      });
    },
    avatar() {
      return get(this.message, 'sender.picture.payload.thumbnail.url', '');
    },

    senderType() {
      return get(this.message, 'sender_type', '');
    },

    avatarAltText() {
      const senderEmail = get(this.message, 'sender.email', '');

      if (senderEmail === BOT_EMAIL) {
        return this.getString('screen.chat.bot_avatar', 'Bot\'s Avatar');
      }

      const senderRole = capitalize(this.senderType).slice(0, -1);
      const senderName = this.senderName || 'default';
      const defaultValue = `${senderRole} ${senderName} avatar`;

      return this.getString(`screen.chat.${this.senderType}_avatar_alt`, { defaultValue, name: senderName });
    },

    imgAltText() {
      const senderRole = this.senderType.slice(0, -1);
      const defaultValue = `Image sent by ${senderRole} ${this.senderName}`;
      return this.getString(`screen.chat.${this.senderType}_img_alt`, { defaultValue, name: this.senderName });
    },

    firstName() {
      return get(this.message, 'sender.profile.first_name', '');
    },

    lastName() {
      return get(this.message, 'sender.profile.last_name', '');
    },

    channelIdentity() {
      return get(this.message, 'payload.external_delivery_info.identity');
    },

    senderName() {
      if (this.channelIdentity) {
        return `${this.firstName} ${this.lastName} via ${this.channelIdentity}`.trim();
      }
      return `${this.firstName} ${this.lastName}`.trim();
    },

    senderInitials() {
      const displayName = get(this.message, 'sender.profile.display_name', '');
      if (get(this.accountFieldsVisibilityConfig, 'display_name.show', true) && !isEmpty(displayName)) {
        return upperFirst(displayName.charAt(0));
      }
      return getInitials(this.firstName, this.lastName);
    },

    textAlign() {
      if (this.type === 'replies') {
        return 'center';
      }

      switch (this.senderType) {
        case 'customers':
          return 'right';
        case 'agents':
          return 'left';
        default:
          return '';
      }
    },

    type() {
      return get(this, 'message.payload.message_type', 'legacy');
    },

    content() {
      return this.applyFilters(get(this.message, `payload.${this.type}.content`));
    },

    attachments() {
      return get(this.message, `payload.${this.type}.attachments`, []);
    },

    maxTime() {
      // isTimestampAbsolute is passed from the toggler in dashboard
      // if true the timestamp is relative for the first 3 hours
      // otherwise it's absolute all the way to the beginning
      const threeHours = calculateSecondsInHours(3); // eslint-disable-line
      return this.isTimestampAbsolute ? LEAST_TIMEAGO_MAX_TIME : threeHours;
    },

    accountFieldsVisibilityConfig() {
      return this.accountFieldsVisibility
        .reduce((acc, item) => ({ ...acc, [item.name]: item }), {});
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
